import React, { useState } from 'react';
import { Input, Button, Modal, Spin, Checkbox } from 'antd';
import { useRemarkForm } from './hooks/useRemarkForm';

const { TextArea } = Input;

const P110CForm: React.FC = () => {
  const {
    mode, isEditing, loading, records, current, currentIdx,
    code, setCode, desc, setDesc, content, setContent, isOld, setIsOld,
    navFirst, navPrev, navNext, navLast,
    startAdd, startEdit, cancel, save, doDelete, quickSearch,
  } = useRemarkForm();

  const [searchText, setSearchText] = useState('');
  const handleDelete = () => {
    if (!current) return;
    Modal.confirm({
      title: '確認刪除', content: `確定要刪除「${current.f10c_01}」？`,
      okText: '刪除', okType: 'danger', cancelText: '取消', onOk: doDelete,
    });
  };
  const modeLabel = mode === 'add' ? '新增' : mode === 'edit' ? '修改' : '瀏覽';

  return (
    <Spin spinning={loading}>
      <div className="max-w-2xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          備註建檔 (pw110cf1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            [{modeLabel}] {records.length > 0 ? `${currentIdx + 1} / ${records.length}` : '無資料'}
          </span>
        </h2>
        <div className="flex items-center gap-2 mb-4">
          <Input placeholder="代號查詢" value={searchText} onChange={e => setSearchText(e.target.value)}
            onPressEnter={() => searchText.trim() && quickSearch(searchText.trim())}
            disabled={isEditing} style={{ width: 150 }} maxLength={2} />
          <Button onClick={() => searchText.trim() && quickSearch(searchText.trim())} disabled={isEditing}>查詢</Button>
        </div>
        <div className="flex items-center gap-1 mb-4">
          <Button size="small" onClick={navFirst} disabled={isEditing || !records.length}>|&lt;</Button>
          <Button size="small" onClick={navPrev} disabled={isEditing || currentIdx <= 0}>&lt;</Button>
          <Button size="small" onClick={navNext} disabled={isEditing || currentIdx >= records.length - 1}>&gt;</Button>
          <Button size="small" onClick={navLast} disabled={isEditing || !records.length}>&gt;|</Button>
        </div>
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">備註代號</label>
            <Input value={code} onChange={e => setCode(e.target.value)} maxLength={2}
              disabled={mode !== 'add'} style={{ width: 100 }} placeholder="2碼" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">說明</label>
            <Input value={desc} onChange={e => setDesc(e.target.value)} maxLength={30}
              disabled={!isEditing} style={{ width: 400 }} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">內容</label>
            <TextArea value={content} onChange={e => setContent(e.target.value)}
              disabled={!isEditing} rows={8} style={{ width: 500 }} />
          </div>
          <div>
            <Checkbox checked={isOld} onChange={e => setIsOld(e.target.checked)} disabled={!isEditing}>
              舊代號
            </Checkbox>
          </div>
        </div>
        {current && mode === 'browse' && (
          <div className="text-xs text-gray-400 mb-6">
            建立者: {current.f10c_91} | 建立日期: {current.f10c_92 || '-'} | 修改者: {current.f10c_93}
          </div>
        )}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <Button type="primary" onClick={startAdd}>新增</Button>
              <Button onClick={startEdit} disabled={!current}>修改</Button>
              <Button danger onClick={handleDelete} disabled={!current}>刪除</Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={save}>儲存</Button>
              <Button onClick={cancel}>取消</Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default P110CForm;
